export default __webpack_public_path__ + "img/bg-tab1and2_nav5-13de1c33.png";